import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getAnalyticsDashboardSuccess, getAnalyticsDashboardFailure,
    getPendingTATSuccess, getPendingTATFailure,
    getTATSuccess, getTATFailure,
    getWorkloadSuccess, getWorkloadFailure,
    getRejectionRateSuccess, getRejectionRateFailure,
    getTestVolumeSuccess, getTestVolumeFailure,
    getQCPerformanceSuccess, getQCPerformanceFailure,
    getOverviewSuccess, getOverviewFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* makeAuthRequest(url, successAction, failureAction) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(successAction(response));
    } catch (error) { yield put(failureAction(error?.response?.message || error)); }
}

function* dashboardRequest() {
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/dashboard`,
        getAnalyticsDashboardSuccess, getAnalyticsDashboardFailure
    );
}

function* pendingTATRequest() {
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/pending-tat`,
        getPendingTATSuccess, getPendingTATFailure
    );
}

function* tatRequest(action) {
    const { days = 30 } = action.payload || {};
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/tat?days=${days}`,
        getTATSuccess, getTATFailure
    );
}

function* workloadRequest(action) {
    const { days = 30 } = action.payload || {};
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/workload?days=${days}`,
        getWorkloadSuccess, getWorkloadFailure
    );
}

function* rejectionRateRequest(action) {
    const { days = 30 } = action.payload || {};
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/rejection-rate?days=${days}`,
        getRejectionRateSuccess, getRejectionRateFailure
    );
}

function* testVolumeRequest(action) {
    const { days = 30 } = action.payload || {};
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/test-volume?days=${days}`,
        getTestVolumeSuccess, getTestVolumeFailure
    );
}

function* qcPerformanceRequest(action) {
    const { days = 30 } = action.payload || {};
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/qc-performance?days=${days}`,
        getQCPerformanceSuccess, getQCPerformanceFailure
    );
}

function* overviewRequest(action) {
    const { days = 30 } = action.payload || {};
    yield* makeAuthRequest(
        `${process.env.REACT_APP_SERVER_API}api/laboratory/analytics/overview?days=${days}`,
        getOverviewSuccess, getOverviewFailure
    );
}

function* saga() {
    yield takeLatest('labAnalytics/getAnalyticsDashboardRequest', dashboardRequest);
    yield takeLatest('labAnalytics/getPendingTATRequest', pendingTATRequest);
    yield takeLatest('labAnalytics/getTATRequest', tatRequest);
    yield takeLatest('labAnalytics/getWorkloadRequest', workloadRequest);
    yield takeLatest('labAnalytics/getRejectionRateRequest', rejectionRateRequest);
    yield takeLatest('labAnalytics/getTestVolumeRequest', testVolumeRequest);
    yield takeLatest('labAnalytics/getQCPerformanceRequest', qcPerformanceRequest);
    yield takeLatest('labAnalytics/getOverviewRequest', overviewRequest);
}

export default saga;
